// extracted by mini-css-extract-plugin
module.exports =  {"label":"_32bbee5fda--label--Nd2Vt","lock":"_32bbee5fda--lock--RVZjg"};